<template>
  <div class="districtnewsdetail">
    <p class="title" v-html="districtnewsitem.title"></p>
    <p class="desc">
      {{ districtnewsitem.sourcename }} {{ districtnewsitem.pubDate }}
    </p>
    <div v-html="newscontent" class="content"></div>
    <nodata :nodata="!districtnewsitem.content" :msg="'暂无数据'"></nodata>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      areaCode: "",
      contentId: "",
      newscontent: "",
      nodata: "",
    };
  },
  methods: {
    replaceUrl(tag, area) {
      if (!this.districtnewsitem.link) {
        this.newscontent = "";
        return;
      }
      let pathArr = this.districtnewsitem.link.split("/");
      if (pathArr.length < tag) {
        this.newscontent = "";
        return;
      }
      let path = pathArr[pathArr.length - tag];
      console.log(path);
      let hosturl = this.districtnewsitem.link.split(path)[0];
      console.log(hosturl);
      let content = this.districtnewsitem.content;

      let temp = `./${path}`;
      let tempurl = `${hosturl}${path}`;
      if ((area = "liucheng")) {
        temp = `src="./`;
        tempurl = `src="${hosturl}${path}/`;
      }
      console.log(temp);
      content = content.replace(new RegExp("!important", "g"), "");
      content = content.replace(new RegExp(temp, "g"), tempurl);
      // console.log(content);
      this.newscontent = content;
    },
  },
  computed: {
    ...mapState({
      districtnewsitem: state => state.districtnews.districtnewsitem,
    }),
  },
  activated() {
    this.areaCode = this.$route.query.areaCode || "";
    switch (this.areaCode) {
      case "450202": //城中区
        this.replaceUrl(3);
        break;
      case "450225": //融水县
        this.replaceUrl(3);
        break;
      case "450222": //柳城县
        this.replaceUrl(2, "liucheng");
        break;
      default:
        this.replaceUrl(2);
    }
  },
  created() {},
};
</script>

<style lang="less">
.districtnewsdetail {
  height: 100%;
  .title {
    padding: 10px 15px 0 15px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 23px;
  }
  .desc {
    padding: 10px 15px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
  }
  .content {
    padding: 10px 15px;
    font-size: 14px !important;
    line-height: 20px !important;
    p {
      font-size: 14px !important;
      line-height: 20px !important;
    }
    span {
      font-size: 14px !important;
      line-height: 20px !important;
    }
    font {
      font-size: 14px !important;
      line-height: 20px !important;
    }
    img {
      width: 100% !important;
      height: auto !important;
      display: block;
      margin-bottom: 10px;
    }
  }
}
</style>
